import { useLingui } from '../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import { Badge } from './Badge.mjs';
import modules_9331f432 from './LastUsed.module.css.mjs';

const LastUsed = ({ children })=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    return /*#__PURE__*/ React__default.createElement("div", {
        className: modules_9331f432.container
    }, children, /*#__PURE__*/ React__default.createElement(Badge, {
        className: modules_9331f432.badge
    }, $__i18n._({
        id: "provider.lastUsed"
    })));
};

export { LastUsed as default };
//# sourceMappingURL=LastUsed.mjs.map
